var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleDottedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_322_56",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM10 16C13.31 16 16 13.31 16 10C16 6.69 13.31 4 10 4C6.69 4 4 6.69 4 10C4 13.31 6.69 16 10 16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM10 16C13.31 16 16 13.31 16 10C16 6.69 13.31 4 10 4C6.69 4 4 6.69 4 10C4 13.31 6.69 16 10 16Z",
    fill: "#E5F6FF",
    stroke: "#1192E8",
    strokeWidth: 2,
    strokeDasharray: "1 1",
    mask: "url(#path-1-inside-1_322_56)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleDottedCircle);
export default __webpack_public_path__ + "static/media/DoubleDottedCircle.6edd0836a04d57d3b82dcfdf0035393b.svg";
export { ForwardRef as ReactComponent };